import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { GlicoLogoComponent } from '../glico-logo/glico-logo.component'

// Layout das telas de acesso: painel da marca (desktop) + formulário
@Component({
  selector: 'auth-layout',
  imports: [GlicoLogoComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  @Input() titulo = ''
  @Input() subtitulo = ''

  digitando = true
  private timer: any

  ngOnInit() {
    this.timer = setTimeout(() => (this.digitando = false), 1600)
  }

  ngOnDestroy() {
    clearTimeout(this.timer)
  }
}
